module.exports = __webpack_public_path__ + "media/janjou.76ba51c1.webm";